import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  background-color: ${(props) =>
    props.opacity ? `rgba(255, 255, 255, ${props.opacity});` : "#fff"};
  width: 100%;
  left: 0;
  top: 0;
  z-index: ${(props) => (props.zIndex ? props.zIndex : "3")};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.7em;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Spinner = styled.img`
  width: 30px;
  height: 30px;
  align-self: center;
`;

export const Text = styled.div`
  font-size: 0.8em;
  margin: 10px 0;
`;
